// extracted by mini-css-extract-plugin
export default {"error__page":"NotFound_error__page__5qkwk","content":"NotFound_content__1b9bZ","header":"NotFound_header__Gs0PY","animate":"NotFound_animate__8jnui","btns":"NotFound_btns__oOnJi"};